import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent {

  /** Si se define, solo muestra estas categorías (p. ej. catálogo Equipos Móviles). */
  @Input() presetCategories: string[] | null = null;

  public collapse: boolean = true;

  get filterbyCategory(): string[] {
    return this.presetCategories?.length ? this.presetCategories : [];
  }

}
